import { render, staticRenderFns } from "./DashboardCMFrotas.vue?vue&type=template&id=23d2e811&scoped=true&"
import script from "./DashboardCMFrotas.vue?vue&type=script&lang=js&"
export * from "./DashboardCMFrotas.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCMFrotas.vue?vue&type=style&index=0&id=23d2e811&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d2e811",
  null
  
)

export default component.exports